<template>
  <div :class="$style.inputArea">
    <div :class="$style.textField">
      <label
        :class="$style.label"
        for="field">{{ computedLabel }}
      </label>
      <div :class="$style.styledSelect">
        <select
          ref="input"
          :field="field"
          :class="$style.inputField"
          :required="computedRequired"
          :placeholder="placeholder"
          :value="value"
          :autocomplete="autocomplete"
          @change="updateValue($event.target.value)">
          <option
            v-if="placeholder"
            value="">{{ placeholder }}
          </option>
          <SelectOption
            v-for="(option, index) in options"
            :option="option"
            :key="getKey(option.name)"/>
        </select>
      </div>
    </div>
    <transition
      :name="$style.fade"
      appear>
      <span
        v-if="error"
        :class="$style.errorMessage"> {{ error }} </span>
    </transition>
  </div>
</template>

<script>
/* Vue Components */
import SelectOption from './FormField.Select.Option.vue';
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */
import validatedFieldMixin from '../../mixins/validatedField';

export default {
  name: 'FormFieldSelect',
  components: {
    SelectOption,
  },
  mixins: [validatedFieldMixin],
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    field: {
      type: String,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    getKey(option) {
      return option.value || option;
    },
  },
};
</script>

<style lang="scss" module>
@import 'src/brand/brandColors.variables';

.inputArea {
  margin: 0 1.6rem 1.6rem 0;
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  max-width: 37.1rem;
}

.textField {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 5rem;
}

.label {
  composes: standard from 'src/brand/typography.scss';
  display: flex;
  justify-content: flex-start;
  padding: 0 2rem;
  align-items: center;
  font-size: 1rem;
  font-weight: 700;
  background: $gray-light;
  color: $steel-gray;
  border: 1px solid $gray-light;
  text-transform: uppercase;
  width: 10rem;
  height: 100%;
}

.inputField {
  composes: standard from 'src/brand/typography.scss';
  font-size: 1.4rem;
  color: $blue-dark;
  background-color: $white;
  height: 5rem;
  flex: 1;
  border: 1px solid $gray-light;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 2.4rem;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: $gray-light;
  }
}

.styledSelect {
  background: url(../../assets/arrow.down.svg) no-repeat right 2.4rem center;
  background-size: 0.96rem;
  overflow: hidden;
  composes: standard from 'src/brand/typography.scss';
  font-size: 1.4rem;
  color: $blue-dark;
  background-color: $white;
  height: 5rem;
  flex: 1;
  border: 1px solid $gray-light;
  border-radius: 0;
  //padding-left: 2.4rem;
  min-width: 200px;
}

.styledSelect select {
  background: transparent;
  border: none;
  font-size: 1.4rem;
  height: 5rem;
  width: 110%;
}

.errorMessage {
  composes: standard from 'src/brand/typography.scss';
  color: $errors;
  display: block;
  margin-top: 0.6rem;
}
</style>
